import get from "lodash/get";

export const getValues = (props) => {
  const isShippingEstimated = get(
    props,
    "summary.totals_v2.shipping_estimated",
    false
  );
  return {
    itemTotal: props.summary.totals.items,
    discountCode: props.summary.promoCode,
    discountAmount: props.summary.totals.discount,
    discountedTotal:
      isShippingEstimated && props.labels.discountestimatedShippingLabel
        ? props.summary.totals_v2.order
        : props.summary.totals.order,
    estimatedShipping: isShippingEstimated
      ? props.summary.totals_v2.shipping
      : props.summary.totals.shipping,
    salesTax: get(props, "summary.totals_v2.tax") || {},
    includedTax: get(props, "summary.totals_v2.tax_included") || {},
    storeCredit: get(props, "summary.store_credits") || {},
  };
};
